"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const sortDynamicCases_1 = __importDefault(require("../../shared/sortDynamicCases"));
exports.default = () => ({ entryVars: { value1 = '', value2 = '', value3 = '', valueDynamic = {}, }, }) => {
    const baseConcat = `${value1}${value2}${value3}`;
    if ((0, valueIsRecord_1.default)(valueDynamic)) {
        const sortValues = (0, sortDynamicCases_1.default)(valueDynamic);
        return sortValues.reduce((accum, [, value]) => (`${accum}${value}`), baseConcat);
    }
    return baseConcat;
};
